"use client";

import type { ComponentProps, FC } from "react";
import { cn } from "../../utils";
import useSlider from "./hooks/useSlider";
import { sliderContentVariants } from "./variants";

type Props = ComponentProps<"div"> & {
  viewportClassName?: string;
  bleed?: "none" | "gutter";
};

const SliderContent: FC<Props> = ({
  className,
  viewportClassName,
  bleed,
  dir,
  ...props
}) => {
  const { scrollRef } = useSlider();

  return (
    <div
      ref={scrollRef}
      dir={dir}
      data-slot="slider-content"
      // The scroller is the flex row itself: with an inner track the slides
      // overflow the track, and the scroller's end padding is dropped.
      className={cn(
        sliderContentVariants({ bleed }),
        viewportClassName,
        className,
      )}
      {...props}
    />
  );
};

export default SliderContent;
